module.exports = __webpack_public_path__ + "static/media/iso.330a9cf7.png";